import { render, staticRenderFns } from "./peopleAddCollec.vue?vue&type=template&id=138e49f5&scoped=true"
import script from "./peopleAddCollec.vue?vue&type=script&lang=js"
export * from "./peopleAddCollec.vue?vue&type=script&lang=js"
import style0 from "./peopleAddCollec.vue?vue&type=style&index=0&id=138e49f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138e49f5",
  null
  
)

export default component.exports